import { OrderStopType } from "@/constants/order";
import type { FreightOrdinals, TripRouteStop, TripStop } from "@/types/trip";

export function getFreightOrdinals(
  stops: (TripStop | TripRouteStop)[],
  freightId: string | undefined,
): FreightOrdinals | null {
  if (!freightId) {
    return null;
  }

  const pickupStops = [...stops]
    .filter((stop) => stop.type === OrderStopType.pickup)
    .sort((a, b) => a.position - b.position);

  const pickupIndex = pickupStops.findIndex((stop) => stop.freights?.includes(freightId));

  if (pickupIndex === -1) {
    return null;
  }

  const freightIndex = pickupStops[pickupIndex].freights.indexOf(freightId);

  if (freightIndex === -1) {
    return null;
  }

  return { pickupOrdinal: pickupIndex + 1, freightOrdinal: freightIndex + 1 };
}

export function getFreightOrdinalLabel(
  stops: (TripStop | TripRouteStop)[],
  freightId: string | undefined,
): string | null {
  const ordinals = getFreightOrdinals(stops, freightId);

  return ordinals ? `${ordinals.pickupOrdinal}-${ordinals.freightOrdinal}` : null;
}
